import {useCallback, useEffect, useRef} from "react";
import {useLocation} from "react-router-dom";
import {OverlayDataType, OverlayType} from "../types/enums";

declare global {
  // noinspection JSUnusedGlobalSymbols
  interface Window {
    _paq: any[];
  }
}

const IN_PRODUCTION = process.env.NODE_ENV === 'production'

export default function MatomoTrackerComponent() {
  const location = useLocation();

  const prevPathname = useRef<string>('');
  const loaded = useRef(false);

  useEffect(() => {
    if (!IN_PRODUCTION) {
      console.log("Matomo is disabled in development mode");
      return;
    }

    if (loaded.current) return;

    const _paq = (window._paq = window._paq || []);
    _paq.push(['enableLinkTracking']);

    const u = "//boonelab.ccbr.utoronto.ca/matomo/";
    _paq.push(['setTrackerUrl', u + 'matomo.php']);
    _paq.push(['setSiteId', '2']);

    const d = document;
    const g = d.createElement('script');
    const s = d.getElementsByTagName('script')[0];
    g.async = true;
    g.src = u + 'matomo.js';

    if (s?.parentNode) {
      s.parentNode.insertBefore(g, s);
    } else {
      // fallback if no script tags exist
      d.head.appendChild(g);
    }

    loaded.current = true;
  }, []);

  // Track every route change
  useEffect(() => {
    if (!IN_PRODUCTION) return;

    // Don't track the same route twice
    if (location.pathname === prevPathname.current) return;

    prevPathname.current = location.pathname;
    const _paq = (window._paq = window._paq || []);
    _paq.push(['setCustomUrl', window.location.href]);
    _paq.push(['trackPageView']);
  }, [location]);

  return null;  // Component renders nothing
}

export function useTrackSearch() {
  const prevSearch = useRef<string>('');

  return useCallback((keyword: string, resultCount?: number) => {
    if (!IN_PRODUCTION) return;
    if (keyword === prevSearch.current) return;

    prevSearch.current = keyword;
    const _paq = (window._paq = window._paq || []);
    _paq.push(['trackSiteSearch', keyword, false, resultCount ?? false]);
  }, []);
}

export function useTrackOverlay() {
  return useCallback((overlayType: OverlayType, overlayDataType: OverlayDataType | string) => {
    if (!IN_PRODUCTION) return;

    const _paq = (window._paq = window._paq || []);
    _paq.push(['trackEvent', 'Overlay', 'Open', overlayType, overlayDataType]);
  }, []);
}